<template>
  <v-card class="mb-4">
    <!-- <v-progress-linear
      class="ma-auto"
      v-show="loading"
      :indeterminate="true"
    /> -->

    <v-toolbar dense>
      <v-toolbar-title>
        Scopes of Practice
      </v-toolbar-title>
      <v-spacer />
      <edit-resource-button
        resource-label="Scope of Practice"
        resource-name="pharmacistsops"
        resource-id-field="personid"
        :resource="{
          personid: personId,
          sopid: null,
          isinactive: false,
          scopedate: new Date()
        }"
        :filter="{ where: { personid: personId } }"
        :resource-id="['personid', 'sopid', 'scopedate']"
        :create-new="true"
        @save="loadscopesofpractice()"
      >
        <template slot-scope="editProps">
          <scope-form :item="editProps.item"></scope-form>
        </template>
      </edit-resource-button>
      <v-btn icon @click="loadscopesofpractice">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="errors.length > 0">
      <v-alert v-for="message in errors" :key="message" type="error">
        {{ message }}
      </v-alert>
    </div>
    <v-data-table
      dense
      :items="scopesofpractice"
      :headers="tableHeaders"
      item-key="batchitemid"
      :loading="loading"
      :options.sync="options"
    >
      <template v-slot:item="props">
        <tr>
          <td>
            <v-icon v-if="props.item.isinactive">remove</v-icon>
            <v-icon color="success" v-else>check</v-icon>
          </td>
          <td>{{ lookup("ScopesOfPractice", props.item.sopid) }}</td>
          <td>
            {{ props.item.scopedate | formatDate }}
          </td>
          <td>{{ props.item.inactivedate | formatDate }}</td>
          <td>
            <edit-resource-button
              resource-label="Scope of Practice"
              resource-name="pharmacistsops"
              resource-id-field="personid"
              :resource="props.item"
              :filter="{ where: { personid: props.item.personid } }"
              :resource-id="['personid', 'sopid', 'datecreated']"
              :create-new="false"
              @save="loadscopesofpractice()"
            >
              <template slot-scope="editProps">
                <scope-form :item="editProps.item"></scope-form>
              </template>
            </edit-resource-button>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import deleteItemButton from "@/components/lib/delete-item-button";
import { mapGetters } from "vuex";
import ScopeForm from "./form";

export default {
  name: "scopeofpracticeList",
  data() {
    return {
      errors: [],
      options: {
        sortDesc: [true],
        sortBy: ["active", "scopedate"]
      },
      tableHeaders: [
        { text: "Active", value: "isinactive", width: "12em" },
        { text: "Scope", value: "sopid" },
        { text: "Start Date", value: "scopedate" },
        { text: "End Date", value: "inactivedate" },
        { text: "", sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup", loading: "isLoading" }),
    scopesofpractice() {
      return (
        this.$store.getters.getById(this.personId)?.practitioner
          ?.scopesonpractice || []
      );
    }
  },
  methods: {
    loadscopesofpractice() {
      if (!this.personId) {
        this.errors.push("personid not defined");
        return;
      }
      this.$store.dispatch("load", this.personId);
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  props: {
    personId: String
  },
  watch: {
    personId: {
      handler: "loadscopesofpractice",
      immediate: true
    }
  },
  filters: {
    currency(amount) {
      return "$" + amount;
    }
  },
  components: {
    "delete-item-button": deleteItemButton,
    "scope-form": ScopeForm
  }
};
</script>
